import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import useUserRoles from 'utils/hooks/auth/useUserRoles';
import { notifyError } from 'utils/notifications';

import Hero from 'react-bulma-components/lib/components/hero';
import Card from 'react-bulma-components/lib/components/card';
import { Column, Container, Row } from 'components/UIComponents/Layout';
import { Content, Heading } from 'components/UIComponents/Typography';
import Button from 'components/UIComponents/Button';

import './style.scss';
import { loginRedirect } from '../../api/authService';
import useUserHasFullAuth from '../../utils/hooks/auth/useUserHasFullAuth';

const LandingPage = () => {
  const isAuthenticated = useUserHasFullAuth();
  const { isMainUser, isReporter, isBlackBoxUploader } = useUserRoles();
  const { t } = useTranslation();

  useEffect(() => {
    if (isAuthenticated && !(isMainUser || isReporter || isBlackBoxUploader))
      notifyError(t('datagate.external.landing.message.noRoles'));
  }, [isAuthenticated, isMainUser, isReporter, isBlackBoxUploader, t]);

  return (
      <div className="landing">
        <Hero color="white" size="medium">
          <Hero.Body className="has-bg-img card-image" />
        </Hero>
        <Container>
          <Card>
            <Row breakpoint="tablet">
              <Column size={10} offset={1} className="pb-5">
                <div className="flex space-between flex-center-y flex-wrap pb-5">
                  <Heading size={2}>
                    {t('datagate.external.landing.title')}
                  </Heading>
                  {!isAuthenticated && (
                      <Button
                          id="login-btn"
                          color="primary"
                          onClick={loginRedirect}
                      >
                        {t('datagate.external.landing.button.login')}
                      </Button>
                  )}
                </div>

                <Content>
                  <div>
                    <Trans
                        components={{
                          paragraph: <p />,
                          list: <ul />,
                          listItem: <li />,
                          chromeDownloadLink: (
                              <a
                                  href="https://www.google.com/chrome/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                              >
                                {' '}
                              </a>
                          ),
                          firefoxDownloadLink: (
                              <a
                                  href="https://www.mozilla.org/et/firefox/all/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                              >
                                {' '}
                              </a>
                          ),
                        }}
                    >
                      datagate.external.landing.text.intro
                    </Trans>
                  </div>
                </Content>
              </Column>
            </Row>
          </Card>
        </Container>
      </div>
  );
};

export default LandingPage;
